<template>
  <el-button-group v-if="isQueueButtonGroupVisible" class="grouped-hamburger d-flex mb-2 me-2">
    <queue-action v-if="showQueueActionsButton" class="el-button el-button--small is-plain p-0" />
    <queue-modal class="el-button el-button--small is-plain p-0" />
  </el-button-group>
</template>

<script>
import QueueModal from './QueueModal'
import QueueAction from './QueueAction'
import hamburgerMixin from './mixin-hamburger'

export default {
  name: 'QueueButtonGroup',
  mixins: [hamburgerMixin],
  components: {
    QueueModal,
    QueueAction,
  },
}
</script>
